import React from 'react';

import { classes, stylesheet } from 'typestyle';
import { OpenSettings } from '../OpenSettings';

interface IProps {
  text: string
}

export function MissingPermission({ text }: IProps) {
  return (
    <div className={classes(sheet.missingPermission, 'alert', 'alert-warning')}>
      <i className={classes('material-icons', 'notranslate', sheet.icon)}>warning</i>
      {text}
      <OpenSettings />
    </div>
  );
}

const sheet = stylesheet({
    missingPermission: {
        background: 'transparent',
        border: '1px solid',
        borderRadius: 3,
        color: '#f3b541',
        marginBottom: 20,
    },
    icon: {
        fontSize: 18,
        verticalAlign: 'middle',
        marginRight: 13,
    },
});
